import React from 'react';
import {
    FileText,
    FileSpreadsheet,
    Image,
    Video,
    Music,
    Archive,
    File,
    FileCode,
    FileJson,
    Presentation,
    FileType,
} from 'lucide-react';

/**
 * Returns the appropriate Lucide icon component based on file type/mime type
 * @param {string} fileType - The file's MIME type or extension
 * @param {string} className - Optional CSS classes
 * @param {number} size - Icon size in pixels
 */
const FileIcon = ({ fileType, className = '', size = 24 }) => {
    const iconProps = { size, className };

    // Normalize to lowercase
    const type = (fileType || '').toLowerCase();

    // PDF
    if (type.includes('pdf')) {
        return <FileText {...iconProps} className={`text-red-500 ${className}`} />;
    }

    // Word documents
    if (type.includes('word') || type.includes('document') || type.includes('.doc')) {
        return <FileText {...iconProps} className={`text-blue-600 ${className}`} />;
    }

    // Spreadsheets
    if (type.includes('sheet') || type.includes('excel') || type.includes('.xls') || type.includes('csv')) {
        return <FileSpreadsheet {...iconProps} className={`text-green-600 ${className}`} />;
    }

    // Presentations
    if (type.includes('presentation') || type.includes('powerpoint') || type.includes('.ppt')) {
        return <Presentation {...iconProps} className={`text-orange-500 ${className}`} />;
    }

    // Images
    if (type.includes('image') || type.includes('.jpg') || type.includes('.png') || type.includes('.gif') || type.includes('.webp') || type.includes('.svg')) {
        return <Image {...iconProps} className={`text-purple-500 ${className}`} />;
    }

    // Videos
    if (type.includes('video') || type.includes('.mp4') || type.includes('.mov') || type.includes('.avi')) {
        return <Video {...iconProps} className={`text-pink-500 ${className}`} />;
    }

    // Audio
    if (type.includes('audio') || type.includes('.mp3') || type.includes('.wav')) {
        return <Music {...iconProps} className={`text-indigo-500 ${className}`} />;
    }

    // Archives
    if (type.includes('zip') || type.includes('compressed') || type.includes('archive') || type.includes('.rar') || type.includes('.7z')) {
        return <Archive {...iconProps} className={`text-yellow-600 ${className}`} />;
    }

    // Code files
    if (type.includes('javascript') || type.includes('typescript') || type.includes('.js') || type.includes('.ts') || type.includes('.py') || type.includes('.html') || type.includes('.css')) {
        return <FileCode {...iconProps} className={`text-emerald-500 ${className}`} />;
    }

    // JSON
    if (type.includes('json')) {
        return <FileJson {...iconProps} className={`text-amber-500 ${className}`} />;
    }

    // Text files
    if (type.includes('text') || type.includes('.txt') || type.includes('.md')) {
        return <FileType {...iconProps} className={`text-gray-600 ${className}`} />;
    }

    // Default
    return <File {...iconProps} className={`text-gray-400 ${className}`} />;
};

export default FileIcon;
